import React, { useState } from "react";
import { Link } from "react-router-dom";
import { interessesDaFicha, marcarInteresseAtendido, urlApi } from "../services/api";

// 🎓 PAINEL DO PARCEIRO — cadastros do modelo novo (22/10/2026): situação de cada ficha (uma por unidade), editar,
// ver a página e os INTERESSADOS recebidos. Só aparecem os pedidos feitos a ESTE parceiro, com o aceite do candidato
// (LGPD): nome, e-mail e telefone, nada do currículo. "Atendido" alimenta o índice de resposta da página.
const STATUS = {
  rascunho: ["Rascunho", "bg-slate-100 text-slate-700"],
  aguardando: ["⏳ Aguardando aprovação", "bg-amber-100 text-amber-800"],
  aprovado: ["✅ No ar", "bg-green-100 text-green-800"],
};
const data = (iso) => (iso ? new Date(iso).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "");

export function MeusCadastrosParceiro({ fichas }) {
  return (
    <section className="mt-4 space-y-3">
      {fichas.map((f) => <CartaoFicha key={f.id} f={f} />)}
      <Link to="/parceiro/cadastro?nova=1" className="inline-block bg-white border border-gray-300 text-gray-700 font-bold rounded-lg px-4 py-2 text-sm">
        ＋ {fichas.length ? "Cadastrar outra unidade" : "Começar meu cadastro"}
      </Link>
    </section>
  );
}

function CartaoFicha({ f }) {
  const [aberto, setAberto] = useState(false);
  const [lista, setLista] = useState(null);
  const [erro, setErro] = useState("");
  const [st, cls] = STATUS[f.status] || [f.status, "bg-slate-100"];
  const abrir = () => {
    setAberto(!aberto);
    if (!lista) interessesDaFicha(f.id).then(setLista).catch((e) => setErro(e.message));
  };
  const marcar = async (i, v) => {
    try { const r = await marcarInteresseAtendido(f.id, i.id, v); setLista((l) => l.map((x) => (x.id === i.id ? { ...x, atendidoEm: r.atendidoEm } : x))); }
    catch (e) { setErro(e.message); }
  };
  return (
    <div className="bg-white rounded-2xl shadow-sm p-5">
      <div className="flex gap-3 items-start">
        <div className="w-12 h-12 shrink-0 rounded-lg bg-accent text-white font-bold flex items-center justify-center overflow-hidden">
          {f.logoUrl ? <img src={urlApi(f.logoUrl)} alt="" className="w-full h-full object-cover" /> : (f.nome || "?").slice(0, 2).toUpperCase()}
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex flex-wrap items-center gap-2">
            <b className="text-text">{f.nome || "Cadastro sem nome"}</b>
            <span className={`rounded-full px-2 py-0.5 text-xs font-semibold ${cls}`}>{st}</span>
            {f.revisaoPendente && <span className="rounded-full px-2 py-0.5 text-xs font-semibold bg-amber-100 text-amber-800">alterações em revisão</span>}
            {f.status === "aprovado" && !f.ativo && <span className="rounded-full px-2 py-0.5 text-xs font-semibold bg-red-100 text-red-700">página pausada</span>}
          </div>
          <div className="text-xs text-gray-500 mt-0.5">{f.tipo === "prof" ? "Professor(a) · aula experimental grátis" : "Escola · bolsa"}{f.enviadoEm ? ` · enviado em ${data(f.enviadoEm)}` : ""}</div>
          {f.motivoRecusa && <p className="mt-2 rounded-lg bg-red-50 border border-red-200 text-red-800 text-xs px-2 py-1.5"><b>Ajuste pedido pelo eaiRH:</b> {f.motivoRecusa}</p>}
          <div className="flex flex-wrap gap-2 mt-3">
            <Link to={`/parceiro/cadastro?id=${f.id}`} className="bg-accent text-white font-bold rounded-lg px-3 py-1.5 text-sm">
              {f.status === "rascunho" ? "Continuar cadastro" : "Editar ficha"}
            </Link>
            {f.pagina && <Link to={f.pagina} className="border border-gray-300 rounded-lg px-3 py-1.5 text-sm font-semibold text-gray-700">Ver minha página</Link>}
            {f.status === "aprovado" && (
              <button type="button" onClick={abrir} className="border border-primary text-primary rounded-lg px-3 py-1.5 text-sm font-semibold">
                Interessados ({f.interesses}{f.novos ? ` · ${f.novos} a atender` : ""}) {aberto ? "▴" : "▾"}
              </button>
            )}
          </div>
        </div>
      </div>
      {aberto && (
        <div className="mt-4 border-t pt-3 text-sm">
          {erro && <p className="text-red-600">{erro}</p>}
          {!lista && !erro && <p className="text-gray-400">Carregando…</p>}
          {lista && lista.length === 0 && <p className="text-gray-500">Nenhum interessado ainda. Cada pedido chega por e-mail aos contatos marcados em "recebe os interessados" e aparece aqui.</p>}
          {lista && lista.length > 0 && (
            <ul className="divide-y">
              {lista.map((i) => (
                <li key={i.id} className="py-2.5 flex flex-wrap gap-3 items-center">
                  <div className="flex-1 min-w-0">
                    <b>{i.nome}</b> <span className="text-xs text-gray-500">· pediu em {data(i.criadoEm)}</span>
                    <div className="text-xs text-gray-700 break-all"><a href={`mailto:${i.email}`} className="text-primary">{i.email}</a> · {i.telefone}</div>
                  </div>
                  <label className="flex items-center gap-1.5 text-xs">
                    <input type="checkbox" checked={!!i.atendidoEm} onChange={(e) => marcar(i, e.target.checked)} /> Atendido
                  </label>
                </li>
              ))}
            </ul>
          )}
          <p className="text-[11px] text-gray-400 mt-2">Use estes dados só para o contato sobre o curso, com no máximo 3 tentativas. Se a pessoa pedir para não ser mais contatada, é só atender.</p>
        </div>
      )}
    </div>
  );
}
